module.exports = __webpack_public_path__ + "static/media/linkedin.2c91f44f.svg";